module.exports = __webpack_public_path__ + "media/中奖上台.9b4978e5.mp3";